import constants from 'scoreboard/components/constants'
const { UNIQUE, MIN_TIME, MAX_TIME, MIN_DATE, MAX_DATE, COUNT, PERCENTAGE } = constants
import DataType from 'scoreboard/datasets/model/data-type'
const { PERCENT, NUMBER, DATE, TIME } = DataType

/**
 * Returns the data type of the result of date with the given data type
 * being aggregated with the given aggregation type. If no aggregation type
 * is specified, the passed-in data type is returned.
 */
function getAggregatedDataType(dataType, aggregationType) {
	switch (aggregationType) {
		case UNIQUE:
			return NUMBER
		case MIN_DATE:
		case MAX_DATE:
			return DATE
		case MIN_TIME:
		case MAX_TIME:
			return TIME
		case COUNT:
			return NUMBER
		case PERCENTAGE:
			return PERCENT
	}
	// if no data type was specified, we were probably dealing with the total
	// field
	return dataType ?? NUMBER
}

export default getAggregatedDataType

getAggregatedDataType.__filename__ = 'components/get-aggregated-data-type.js'
